import { ConstructionTypeContainer } from '../../containers/advancedFilters/ConstructionTypeContainer';
import { IFilter } from '../../types/filters';

export const constructionType: IFilter = {
  component: ConstructionTypeContainer,
};
